import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=a009017e&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=a009017e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a009017e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
